<template>
    <div class="form-group">
        <FormLabel :required="this.required">{{ label }}</FormLabel>
        <div>
            <FormInput
                :class="inputClass ? inputClass : 'w-full'" :options="options"
                :autocomplete="autocomplete" :placeholder="placeholder"
                :type="type" :value="value" @input="v => $emit('input', v)"/>
            <ErrorText :name="name" :errors="errors"/>
        </div>
    </div>
</template>

<script>
import FormLabel from "./FormLabel";
import FormInput from "./FormInput";
import ErrorText from "../ErrorText";

export default {
    name: "FormGroup",
    components: {ErrorText, FormInput, FormLabel},
    props: {
        name: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true,
        },
        value: {
            type: String | Number | Boolean,
        },
        placeholder: {
            type: String,
        },
        type: {
            type: String,
            default: 'text'
        },
        errors: {
            type: Object | Array
        },
        inputClass: {
            type: String,
        },
        autocomplete: {
            type: String
        },
        options: {
            type: Array
        },
        required: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>

</style>
